import {
  getReq,
  postReq,
  deleteSendReq,
  putReq,
  getCPHeaderMap,
  getHeaderCodeMap,
  END_POINTS
} from '@/api'
import * as Utils from '@/utils'

// const baseUrl = process.env.BASE_URL

const state = {
  projSettleEntityList: [],
  projSettleEntityInfo: {
    entityId: '',
    projId: '',
    entityName: '',
    entityDesc: '',
    ctrAcctId: '',
    colId: '',
    costColId: '',
    entityContact: '',
    content: '',
    compId: '',
    colType: '',
    seq: 0,
    contractNo: '',
    status: '',
    entityStatus: '',
    lockBy: '',
    lockOn: new Date(0),
    crtBy: '',
    crtOn: new Date(0),
    updBy: '',
    updOn: new Date(0),
    //
    indUsed: ''
  },
  editIndex: -1,
  editAction: '',
  END_STATE: null
}

const getters = {

}

const actions = {
  async insertProjSettleEntity({
    dispatch,
    commit,
    state
  }, {projId, compId, codeParam}) {
    // debugger
    const insertObj = await postReq(END_POINTS.INSERT_RSP_PROJ_SETTLE_ENTITY, {
      data: {
        entityName: state.projSettleEntityInfo.entityName,
        ctrAcctId: state.projSettleEntityInfo.ctrAcctId,
        costColId: state.projSettleEntityInfo.costColId,
        entityContact: state.projSettleEntityInfo.entityContact,
        content: state.projSettleEntityInfo.content,
        contractNo: state.projSettleEntityInfo.contractNo,
        // status: state.projSettleEntityInfo.status,
        //
        projId: projId,
        compId: compId
      },
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return insertObj
  },
  async updateProjSettleEntityKeyInfo({
    dispatch,
    commit,
    state
  }, {entityId, projId, compId, codeParam}) {
    // debugger
    let projSettleEntityInfo = {
      entityName: state.projSettleEntityInfo.entityName,
      ctrAcctId: state.projSettleEntityInfo.ctrAcctId,
      costColId: state.projSettleEntityInfo.costColId,
      // entityContact: state.projSettleEntityInfo.entityContact,
      content: state.projSettleEntityInfo.content,
      // contractNo: state.projSettleEntityInfo.contractNo,
      // status: state.projSettleEntityInfo.status,
      //
      key: {
        entityId: entityId,
        projId: projId,
        compId: compId
      }
    }
    const updateObject = await putReq(END_POINTS.UPDATE_RSP_PROJ_SETTLE_ENTITY_KEY_INFO, {
      data: projSettleEntityInfo,
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return updateObject
  },
  async updateProjSettleEntity({
    dispatch,
    commit,
    state
  }, {entityId, projId, compId, codeParam}) {
    // debugger
    let projSettleEntityInfo = {
      entityName: state.projSettleEntityInfo.entityName,
      ctrAcctId: state.projSettleEntityInfo.ctrAcctId,
      costColId: state.projSettleEntityInfo.costColId,
      entityContact: state.projSettleEntityInfo.entityContact,
      content: state.projSettleEntityInfo.content,
      contractNo: state.projSettleEntityInfo.contractNo,
      // status: state.projSettleEntityInfo.status,
      //
      key: {
        entityId: entityId,
        projId: projId,
        compId: compId
      }
    }
    const updateObject = await putReq(END_POINTS.UPDATE_RSP_PROJ_SETTLE_ENTITY, {
      data: projSettleEntityInfo,
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return updateObject
  },
  async removeProjSettleEntity({
    commit,
    state
  }, {entityId, projId, compId, codeParam}) {
    const deleteObject = await deleteSendReq(END_POINTS.REMOVE_RSP_PROJ_SETTLE_ENTITY + `?entityId=${entityId}&projId=${projId}&compId=${compId}`, {
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return deleteObject
  },
  async findProjSettleEntity({
    commit
  }, {entityId, projId, compId, codeParam}) {
    const responseData = await getReq(END_POINTS.FIND_RSP_PROJ_SETTLE_ENTITY + `?entityId=${entityId}&projId=${projId}&compId=${compId}`, {
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    if (responseData.success) {
      commit('updateProjSettleEntityInfo', responseData.data)
    } else {
      commit('updateProjSettleEntityInfo', {})
    }
  },
  async findProjSettleEntityList({
    commit,
    state,
    rootState
  }, { projId, compId, codeParam }) {
    const response = await getReq(END_POINTS.FIND_RSP_PROJ_SETTLE_ENTITY_LIST + `?projId=${projId}&compId=${compId}`, {
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    commit('updateProjSettleEntityList', response)
  },
  async findProjSettleEntityStatisticList({
    commit,
    state,
    rootState
  }, { projId, compId, searchedForm, codeParam }) {
    // let searchedForm = state.searchedForm || state.emptySearchInfo
    let data = {
      projId,
      compId,
      entityName: searchedForm.searchEntityName,
      searchType: searchedForm.searchType,
      searchMonth: new Date(Utils.getMonthFirstDay(searchedForm.searchMonth)).getTime(),
      searchMonthType: searchedForm.searchMonthType,
      startDt: new Date(searchedForm.searchStartDt).getTime(),
      endDt: new Date(searchedForm.searchEndDt).getTime()
    }
    const response = await postReq(END_POINTS.FIND_RSP_PROJ_SETTLE_ENTITY_STATISTIC_LIST, {
      data,
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    commit('updateProjSettleEntityList', response)
  },
  END_ACTIONS() {}
}

const mutations = {
  updateProjId(state, value) {
    state.projSettleEntityInfo.projId = value
  },
  updateEntityId(state, value) {
    state.projSettleEntityInfo.entityId = value
  },
  updateEntityName(state, value) {
    state.projSettleEntityInfo.entityName = value
  },
  updateEntityDesc(state, value) {
    state.projSettleEntityInfo.entityDesc = value
  },
  updateCtrAcctId(state, value) {
    state.projSettleEntityInfo.ctrAcctId = value
  },
  updateColId(state, value) {
    state.projSettleEntityInfo.colId = value
  },
  updateCostColId(state, value) {
    state.projSettleEntityInfo.costColId = value
  },
  updateEntityContact(state, value) {
    state.projSettleEntityInfo.entityContact = value
  },
  updateContent(state, value) {
    state.projSettleEntityInfo.content = value
  },
  updateCompId(state, value) {
    state.projSettleEntityInfo.compId = value
  },
  updateColType(state, value) {
    state.projSettleEntityInfo.colType = value
  },
  updateSeq(state, value) {
    state.projSettleEntityInfo.seq = value
  },
  updateContractNo(state, value) {
    state.projSettleEntityInfo.contractNo = value
  },
  updateStatus(state, value) {
    state.projSettleEntityInfo.status = value
  },
  updateEntityStatus(state, value) {
    state.projSettleEntityInfo.entityStatus = value
  },
  updateLockBy(state, value) {
    state.projSettleEntityInfo.lockBy = value
  },
  updateLockOn(state, value) {
    state.projSettleEntityInfo.lockOn = value
  },
  updateCrtBy(state, value) {
    state.projSettleEntityInfo.crtBy = value
  },
  updateCrtOn(state, value) {
    state.projSettleEntityInfo.crtOn = value
  },
  updateUpdBy(state, value) {
    state.projSettleEntityInfo.updBy = value
  },
  updateUpdOn(state, value) {
    state.projSettleEntityInfo.updOn = value
  },
  updateProjSettleEntityList(state, response) {
    if (response.success === true && response.data.length) {
      state.projSettleEntityList = response.data
    } else {
      state.projSettleEntityList = []
    }
  },
  updateProjSettleEntityListEmpty(state) {
    state.editIndex = -1
    state.projSettleEntityList = []
  },
  updateProjSettleEntityEmpty(state) {
    state.projSettleEntityInfo.projId = ''
    state.projSettleEntityInfo.entityId = ''
    state.projSettleEntityInfo.entityName = ''
    state.projSettleEntityInfo.entityDesc = ''
    state.projSettleEntityInfo.ctrAcctId = ''
    state.projSettleEntityInfo.colId = ''
    state.projSettleEntityInfo.costColId = ''
    state.projSettleEntityInfo.entityContact = ''
    state.projSettleEntityInfo.content = ''
    state.projSettleEntityInfo.compId = ''
    state.projSettleEntityInfo.colType = ''
    state.projSettleEntityInfo.seq = 0
    state.projSettleEntityInfo.contractNo = ''
    state.projSettleEntityInfo.status = ''
    state.projSettleEntityInfo.entityStatus = ''
    state.projSettleEntityInfo.lockBy = ''
    state.projSettleEntityInfo.lockOn = new Date(0)
    state.projSettleEntityInfo.crtBy = ''
    state.projSettleEntityInfo.crtOn = new Date(0)
    state.projSettleEntityInfo.updBy = ''
    state.projSettleEntityInfo.updOn = new Date(0)

    state.projSettleEntityInfo.indUsed = ''
  },
  updateProjSettleEntityInfo(state, projSettleEntityInfo) {
    // debugger
    state.projSettleEntityInfo.projId = projSettleEntityInfo.projId
    state.projSettleEntityInfo.entityId = projSettleEntityInfo.entityId
    state.projSettleEntityInfo.entityName = projSettleEntityInfo.entityName
    state.projSettleEntityInfo.entityDesc = projSettleEntityInfo.entityDesc
    state.projSettleEntityInfo.ctrAcctId = projSettleEntityInfo.ctrAcctId
    state.projSettleEntityInfo.colId = projSettleEntityInfo.colId
    state.projSettleEntityInfo.costColId = projSettleEntityInfo.costColId
    state.projSettleEntityInfo.entityContact = projSettleEntityInfo.entityContact
    state.projSettleEntityInfo.content = projSettleEntityInfo.content
    state.projSettleEntityInfo.compId = projSettleEntityInfo.compId
    state.projSettleEntityInfo.colType = projSettleEntityInfo.colType
    state.projSettleEntityInfo.seq = projSettleEntityInfo.seq
    state.projSettleEntityInfo.contractNo = projSettleEntityInfo.contractNo
    state.projSettleEntityInfo.status = projSettleEntityInfo.status
    state.projSettleEntityInfo.entityStatus = projSettleEntityInfo.entityStatus
    state.projSettleEntityInfo.lockBy = projSettleEntityInfo.lockBy
    state.projSettleEntityInfo.lockOn = projSettleEntityInfo.lockOn
    state.projSettleEntityInfo.crtBy = projSettleEntityInfo.crtBy
    state.projSettleEntityInfo.crtOn = projSettleEntityInfo.crtOn
    state.projSettleEntityInfo.updBy = projSettleEntityInfo.updBy
    state.projSettleEntityInfo.updOn = projSettleEntityInfo.updOn
    //
    state.projSettleEntityInfo.indUsed = projSettleEntityInfo.indUsed
  },
  updateEditIndex(state, value) {
    state.editIndex = value
  },
  updateEditAction(state, value) {
    state.editAction = value
  },
  // newEmptyRowObj() {
  //   return {
  //     ctrAcctId: '',
  //     type: '',
  //     indUsed: '',
  //     status: ''
  //   }
  // },
  appendBottomRow() {
    this.commit('confProjSettleEntityManage/updateProjSettleEntityEmpty')
    let obj = {...state.projSettleEntityInfo}
    // debugger
    obj.isBottomRow = true
    state.projSettleEntityList.push(obj)
  },
  handleAdd(state, {row, index, ctrAcctId, costColId}) {
    // debugger
    this.commit('confProjSettleEntityManage/updateProjSettleEntityEmpty')
    this.commit('confProjSettleEntityManage/updateEditIndex', index)
    this.commit('confProjSettleEntityManage/updateEditAction', 'insert')
    //
    this.commit('confProjSettleEntityManage/updateCtrAcctId', ctrAcctId)
    this.commit('confProjSettleEntityManage/updateCostColId', costColId)
  },
  handleEdit(state, {row, index}) {
    // debugger
    this.commit('confProjSettleEntityManage/updateProjSettleEntityInfo', row)
    this.commit('confProjSettleEntityManage/updateEditIndex', index)
    this.commit('confProjSettleEntityManage/updateEditAction', 'update')
  },
  END_MUTATIONS() {}
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/proj/project/confProjSettleEntityManage.js